import axios from "axios";
import cognitoService from './cognitoService';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add Cognito JWT token to requests if available
api.interceptors.request.use(
  async (config) => {
    try {
      // Get JWT token from Cognito session
      const token = await cognitoService.getJwtToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Error getting authentication token:', error);
      // Continue with request without token
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for debugging
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error("API Error:", error.message);
    if (error.response) {
      console.error("Status:", error.response.status);
      console.error("Data:", error.response.data);
    }
    return Promise.reject(error);
  }
);

export const getStats = async () => {
  try {
    console.log("Fetching stats from:", `${API_URL}/stats`);
    // Return mock data for now to ensure the page works without authentication
    return {
      customers: 1250,
      accounts: 3427
    };
    
    // Uncomment this to use the actual API when it's ready
    // const response = await api.get("/stats");
    // return response.data;
  } catch (error) {
    console.error("Error fetching stats:", error);
    throw error;
  }
};

export default api;
